export enum CIVILITE {
    MONSIEUR = 'Monsieur',
    MADAME = 'Madame'
}
